export default {"src":"/_next/static/media/logo-square-white.a0801cc4.svg","height":90,"width":108,"blurWidth":0,"blurHeight":0};